export default __webpack_public_path__ + "static/media/Snd_TryZ.7dc01569.mp3";